import "./timer-progress.less"
import { classNames } from "utils/helpers"
import { usePlayState } from "play/hooks/use-play-state"

export default function TimerProgress(props: { isVisible: boolean }) {
  const { timer } = usePlayState()
  const progress = timer.progress

  if (!props.isVisible) return null

  const width = 100 * progress

  return (
    <div
      className={classNames("timer-progress", {
        ok: width < 60,
        warning: width >= 60 && width < 80,
        danger: width >= 80,
      })}
      style={{
        width: `${width}%`,
      }}
    />
  )
}
